import { render, staticRenderFns } from "./Four_boxgrid.vue?vue&type=template&id=912c99a6&scoped=true"
import script from "./Four_boxgrid.vue?vue&type=script&lang=js"
export * from "./Four_boxgrid.vue?vue&type=script&lang=js"
import style0 from "./Four_boxgrid.vue?vue&type=style&index=0&id=912c99a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912c99a6",
  null
  
)

export default component.exports